<template>
	<div class="item-container">
		<div
			v-for="(item, index) in itemList"
			:key="'item' + index"
			:id="'item' + index"
			class="placed-item"
			:draggable="$isAllowedTo('floor_areas_edit')"
			@dragstart="dragStart(index, $event)"
			@dragend.prevent="dragEnd"
			@contextmenu.prevent="removeItem(item)"
			@click="openMenu($event, item)"
			@drag="drag"
			:style="{
				bottom: item.positionY * areaHeightRatio - 15 * itemScale(item) + 'px',
				left: item.positionX * areaWidthRatio - 15 * itemScale(item) + 'px',
				width: getItemSize(item),
				height: getItemSize(item),
				'pointer-events': disable ? 'none' : 'all'
			}"
		>
			<div
				class="inner"
				:class="getItemType(item)"
				:style="{ transform: `rotateZ(${item.rotation}deg)` }"
			></div>
		</div>
	</div>
</template>

<script>
import iconMixin from '@/mixins/iconMixin.js';
import { mapGetters } from 'vuex';
export default {
	mixins: [iconMixin],
	model: {
		prop: 'movingItem',
		event: 'itemStatus'
	},
	props: {
		items: Array,
		areaWidthRatio: Number,
		areaHeightRatio: Number,
		zoomLevel: Number,
		disable: Boolean
	},
	data() {
		return {
			move: false,
			itemIndex: 0,
			dragX: 0,
			dragY: 0,
			itemList: [],
			dragOffset: {
				x: 0,
				y: 0
			}
		};
	},
	watch: {
		items: {
			deep: true,
			immediate: true,
			handler() {
				let list = [];
				let groups = [];
				this.items.forEach(item => {
					let added = false;
					list.forEach(match => {
						const biggestScale = match.scale > item.scale ? match.scale : item.scale;
						const groupDistance = 19 * biggestScale;

						if (
							item.positionX < match.positionX + groupDistance &&
							item.positionX > match.positionX - groupDistance &&
							item.positionY < match.positionY + groupDistance &&
							item.positionY > match.positionY - groupDistance
						) {
							added = true;
							const groupIndex = groups.findIndex(
								group => group.items[0].id === match.id
							);

							if (groupIndex !== -1) {
								item.positionX = groups[groupIndex].positionX;
								item.positionY = groups[groupIndex].positionY;
								groups[groupIndex].items.push(item);
							} else {
								const group = {
									positionX: match.positionX,
									positionY: match.positionY,
									items: [match, item],
									type: 'Grupp',
									rotation: 0,
									scale: (match.scale + item.scale) / 2
								};
								groups.push(group);
							}
						}
					});

					if (!added) {
						list.push(item);
					}

					added = false;
				});
				groups.forEach(group => {
					const itemIndex = list.findIndex(
						item => item.id === group.items[0].id
					);
					list.splice(itemIndex, 1);
				});
				list = list.concat(groups);
				this.itemList = list;
			}
		}
	},
	computed: {
		...mapGetters('appStore', ['isMobile'])
	},
	methods: {
		dragStart(index, ev) {
			this.$emit('itemStatus', true);

			if (!this.isMobile) {
				const crt = ev.target.cloneNode(true);

				crt.style.position = 'absolute';
				crt.style.top = '0px';
				crt.style.left = '-1000px';

				const inner = crt.getElementsByClassName('inner')[0];
				const scale = this.zoomLevel;
				const dpiComp = window.devicePixelRatio === 1 ? 1 : (1 / window.devicePixelRatio) * 0.75;

				inner.style.transform = `scale(${scale}) translate(-100%, -100%) rotateZ(${this.itemList[index].rotation}deg)`;

				document.body.appendChild(crt);

				ev.dataTransfer.setDragImage(
					crt,
					(ev.offsetX * scale) / dpiComp,
					(ev.offsetY * scale) / dpiComp
				);
			}

			const iconScale = this.itemScale(this.itemList[index]);
			const iconSize = ev.target.offsetWidth / 2;

			ev.dataTransfer.setData('text', ev.target.id);

			this.move = true;
			this.itemIndex = index;
			this.dragX = (iconSize - ev.offsetX) * iconScale;
			this.dragY = (ev.offsetY - iconSize) * iconScale;
		},

		getItemType(item) {
			if (!item.fireProtection && !item.type) return;

			if (item.type === 'Grupp') return 'group';

			return this.getType(item.fireProtection.inventoryType);
		},

		drag(ev) {
			this.dragOffset.x = ev.offsetX;
			this.dragOffset.y = ev.offsetY;
		},

		dragEnd(ev) {
			const dropZone = document.getElementById('dropZone');
			const dropZoneHeight = dropZone.offsetHeight / this.areaHeightRatio;
			const offsetX =
        ev.offsetX !== this.dragOffset.x ? this.dragOffset.x : ev.offsetX;
			const offsetY =
        ev.offsetY !== this.dragOffset.y ? this.dragOffset.y : ev.offsetY;

			let finalOffsetX = (offsetX + this.dragX) / this.areaWidthRatio;
			let finalOffsetY =
        dropZoneHeight - (offsetY - this.dragY) / this.areaHeightRatio;

			if (ev.target.classList.contains('placed-item')) {
				finalOffsetX =
          (ev.target.offsetLeft + offsetX + this.dragX / this.zoomLevel) /
          this.areaWidthRatio;
				finalOffsetY =
          dropZoneHeight -
          (ev.target.offsetTop + offsetY - this.dragY / this.zoomLevel) /
            this.areaHeightRatio;
			}

			this.itemList[this.itemIndex].positionX = finalOffsetX;
			this.itemList[this.itemIndex].positionY = finalOffsetY;

			if (this.itemList[this.itemIndex].type) {
				this.itemList[this.itemIndex].items.forEach(item => {
					item.positionX = finalOffsetX;
					item.positionY = finalOffsetY;
					item.fireProtectionId = item.fireProtection.id;
					this.saveMapItem(item);
				});
			} else {
				this.itemList[this.itemIndex].fireProtectionId = this.itemList[
					this.itemIndex
				].fireProtection.id;
				this.saveMapItem(this.itemList[this.itemIndex]);
			}

			this.$emit('itemStatus', false);
		},

		removeItem(item) {
			if (!item.type && this.$isAllowedTo('floor_areas_edit')) this.$emit('deleteMapItem', item);
		},

		itemScale(item) {
			return item.scale < 0.3
				? 1 * this.areaWidthRatio
				: item.scale * this.areaWidthRatio;
		},

		getItemSize(item) {
			return `${Math.round(30 * this.itemScale(item))}px`;
		},

		saveMapItem(item) {
			item.positionX = parseInt(item.positionX);
			item.positionY = parseInt(item.positionY);
			this.$emit('saveMapItem', item);
		},

		openMenu($event, item) {
			this.$emit('openMenu', $event, item);
		}
	}
};
</script>

<style lang="scss" scoped>
.item-container {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.placed-item {
  background-color: transparent;
  width: 30px;
  height: 30px;
  cursor: pointer;
  z-index: 2;
  position: absolute;
  background-size: contain;
  .inner {
    width: 100%;
    height: 100%;
    pointer-events: none;
    background-size: contain;
  }
}
</style>
